var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import ConfigStore, { getConfigStore } from './store/ConfigStore';
import { configServices } from './services/ConfigServices';
import StoreModule, { getModule } from '@/modules/store';
import * as LocalStorageUtils from '@/utils/LocalStorageUtils';
import { userServices } from '../users/services/UserServices';
export var ASSET_ORGANIZATION_ID = process.env.VUE_APP_ASSET_ORGANIZATION_ID;
var ConfigModule = (function (_super) {
    __extends(ConfigModule, _super);
    function ConfigModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigModule.prototype.preInstall = function (options) {
        var _this = this;
        var configStore;
        return new Promise(function (resolve, reject) {
            var storeModule = options.appModule.getModuleByType(StoreModule);
            storeModule.store.registerModule('config', ConfigStore);
            configServices.getConfig().then(function (data) {
                var config = data;
                configStore = getConfigStore();
                configStore.setConfig(config);
                return _this.getUserData();
            }).then(function (result) {
                resolve(true);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    ConfigModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    ConfigModule.prototype.getUserData = function () {
        return new Promise(function (resolve, reject) {
            if (process.env.PUBLIC_DOCUMENT) {
                resolve(null);
                return;
            }
            else if (process.env.RECIPIENT_PUBLIC_PROFILE) {
                var configStore_1 = getModule(ConfigStore);
                userServices.getPublicUser().then(function (user) {
                    console.log('got a public user', user, typeof user);
                    configStore_1.setUser(user);
                    configStore_1.setUserLanguage(user.language);
                    resolve(user);
                }).catch(function (error) {
                    reject(error);
                });
                return;
            }
            var defaultToken = process.env.VUE_USER_TOKEN;
            var defaultLanguage = 'en';
            var urlParams = new URLSearchParams(window.location.search);
            var urlParamsToken = urlParams.get('Token');
            console.log('getting user creds', urlParamsToken, LocalStorageUtils.getItem('cv-user-language', ''), LocalStorageUtils.getItem('cv-user-token', ''));
            var userLanguage = sessionStorage.getItem('cv-user-language') || LocalStorageUtils.getItem('cv-user-language', '') || defaultLanguage;
            var userToken = urlParamsToken || sessionStorage.getItem('cv-user-token') || LocalStorageUtils.getItem('cv-user-token', '') || defaultToken;
            if (userLanguage === 'undefined' || !userLanguage)
                userLanguage = defaultLanguage;
            console.log('process', process, process.env);
            if (!userToken) {
                reject(new Error('User Token is missing'));
            }
            else {
                var configStore_2 = getModule(ConfigStore);
                configStore_2.setUserToken(userToken);
                userServices.getUser().then(function (user) {
                    console.log('got a user', user, typeof user);
                    configStore_2.setUser(user);
                    configStore_2.setUserLanguage(user.language);
                    resolve(user);
                }).catch(function (error) {
                    reject(error);
                });
            }
        });
    };
    return ConfigModule;
}(BaseModule));
export default ConfigModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/config/index.ts
// module id = 3hwC
// module chunks = 10